const { CarouselElement } = window.BAO.Carousel

export class FeaturedBlogArticlesCarousel extends CarouselElement {
  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      loop: true,
      slides: {
        origin: 'center',
        perView: 1.5,
        spacing: 10,
      },
      breakpoints: {
        '(min-width: 768px)': {
          disabled: true,
        },
      },
    }
  }
}

if (!window.customElements.get('featured-blog-articles-carousel')) {
  window.customElements.define(
    'featured-blog-articles-carousel',
    FeaturedBlogArticlesCarousel,
  )
}
